
export default function RitualLogo({ size = 40 }) {
  return (
   <svg
    width="40"
    height="40"
    viewBox="0 0 62 62"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2.5" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#glow)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5294 28.5991L23.5293 30.612L30.4705 23.6257L28.4706 21.6127L21.5294 28.5991Z"
        fill="#D100D1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 31.1449L16 38.1905L20.4706 33.6908L18.4706 31.6777L16 34.1644L13 31.1449L16 28.1254L23.4706 35.6446L25.4705 33.6316L15.9999 24.0994L9 31.1449Z"
        fill="#D100D1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5294 26.6453L26.5294 28.6582L33.4706 35.6446L35.4706 33.6316L28.5294 26.6453Z"
        fill="#00FFFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.4706 33.6908L38.4705 31.6778L31.5294 38.6641L33.5294 40.6772L40.4706 33.6908Z"
        fill="#D100D1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 21.0798L23.4706 25.5795L25.4706 23.5665L23 21.0799L26 18.0603L33.4706 25.5795L35.4706 23.5665L26 14.0343L19 21.0798Z"
        fill="#D100D1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.5294 38.7234L36 48.2556L43 41.21L38.5294 36.7104L36.5293 38.7235L38.9999 41.2102L35.9999 44.2297L28.5293 36.7105L26.5294 38.7234Z"
        fill="#00FFFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5294 28.6583L46 38.1905L53 31.1449L46 24.0994L41.5294 28.5991L43.5294 30.6121L46 28.1255L49 31.145L46 34.1645L38.5294 26.6453L36.5294 28.6583Z"
        fill="#D100D1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 41.21L26 48.2556L30.4706 43.7559L28.4706 41.7428L26 44.2295L23 41.21L30.4706 33.6908L28.4705 31.6777L19 41.21Z"
        fill="#D100D1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.5303 18.5331L33.5302 20.5461L36.0008 18.0594L39.0008 21.079L31.5302 28.5982L33.5302 30.6112L43.0008 21.0789L36.0008 14.0334L31.5303 18.5331Z"
        fill="#D100D1"
      />
      <path d="M27.4119 12.6511L31.0393 9L34.6668 12.6511L31.0393 16.3022L27.4119 12.6511Z" fill="#00FFFF" />
      <path d="M27.4119 49.3489L31.0394 45.6978L34.6668 49.3489L31.0394 53L27.4119 49.3489Z" fill="#00FFFF" />
    </g>
  </svg>
  );
}
